import React from 'react';
import MarkdownToJsx from 'markdown-to-jsx';
import styled from 'styled-components';

const Paragraph = styled.p`
  margin: 0;

  &:not(:first-child) {
    margin-top: 20px;
  }
`;

interface CustomMarkdownProps {
  children: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components?: Record<string, React.ComponentType<any>>;
}

export function Markdown({ children, components = {} }: CustomMarkdownProps) {
  const overrides = Object.entries(components).reduce(
    (acc, [name, component]) => ({
      ...acc,
      [name]: { component },
    }),
    {
      p: {
        component: Paragraph,
      },
    },
  );

  return <MarkdownToJsx options={{ overrides }}>{children}</MarkdownToJsx>;
}
